// extracted by mini-css-extract-plugin
export default {"level0":"Cy_6fc","level1":"znd8uY"};